import { render, staticRenderFns } from "./preTable2_left.vue?vue&type=template&id=828f6114&scoped=true&"
import script from "./preTable2_left.vue?vue&type=script&lang=js&"
export * from "./preTable2_left.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828f6114",
  null
  
)

export default component.exports